export type TValidDiplomaEndorsements = 'Arts' | 'CDOS' | 'CTE' | 'Honors' | 'Mastery in Math' | 'Mastery in Science';

export interface IEndorsement {
  human: TValidDiplomaEndorsements;
  checkbox: {
    isIndeterminate: boolean;
  };
}

export const PlannedDiplomaEndorsements = {
  arts: {
    human: 'Arts',
    checkbox: {
      isIndeterminate: true,
    },
  } as IEndorsement,
  cdos: {
    human: 'CDOS',
    checkbox: {
      isIndeterminate: true,
    },
  } as IEndorsement,
  cte: {
    human: 'CTE',
    checkbox: {
      isIndeterminate: true,
    },
  } as IEndorsement,
  honors: {
    human: 'Honors',
    checkbox: {
      isIndeterminate: true,
    },
  } as IEndorsement,
  math: {
    human: 'Mastery in Math',
    checkbox: {
      isIndeterminate: true,
    },
  } as IEndorsement,
  sci: {
    human: 'Mastery in Science',
    checkbox: {
      isIndeterminate: true,
    },
  } as IEndorsement,
};
